import Numeric from "./numeric.component.js";

export default angular
    .module("oui.numeric", [])
    .component("ouiNumeric", Numeric)
    .name;
